export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS

    /* eslint-disable */
    $('#home-slider > div > div > div').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      autoplay: true,
      autoplaySpeed: 10000,
      pauseOnFocus: false,
      pauseOnHover: false,
      speed: 800
    });
    /* eslint-enable */
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js